var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLinks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 312,
    width: 25,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 312,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 312,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 312,
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-641 -312)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M654.604 322.886C654.842 322.646 655.202 322.596 655.487 322.747L655.583 322.807 655.673 322.886 655.815 323.039C656.862 324.232 656.962 326 656.083 327.303L655.963 327.471 655.832 327.632 655.667 327.81 651.239 332.285 651.074 332.441C650.448 332.996 649.647 333.3 648.808 333.3 648.13 333.3 647.474 333.101 646.914 332.727L646.731 332.597 646.557 332.454 646.37 332.278 645.709 331.61 645.554 331.443C645.001 330.81 644.7 330.004 644.7 329.151 644.7 328.464 644.897 327.803 645.268 327.237L645.398 327.052 645.541 326.875 645.716 326.685 649.243 323.151 649.334 323.073C649.633 322.855 650.045 322.887 650.309 323.153 650.515 323.362 650.582 323.666 650.491 323.938L650.45 324.039 650.386 324.143 650.295 324.25 646.78 327.771 646.662 327.901C646.151 328.518 646.073 329.39 646.448 330.083L646.535 330.229 646.636 330.368 646.768 330.519 647.443 331.201 647.572 331.32C648.182 331.836 649.045 331.915 649.732 331.536L649.876 331.448 650.014 331.346 650.163 331.212 654.603 326.724 654.721 326.594C655.231 325.977 655.309 325.106 654.934 324.413L654.847 324.267 654.746 324.128 654.611 323.975 654.531 323.88C654.31 323.572 654.339 323.154 654.604 322.886ZM656.914 315.573C658.095 314.514 659.842 314.413 661.131 315.3L661.297 315.422 661.457 315.555 661.634 315.722 662.295 316.391 662.45 316.558C663.001 317.192 663.3 317.998 663.3 318.849 663.3 319.536 663.103 320.197 662.731 320.764L662.601 320.949 662.458 321.127 662.282 321.317 658.754 324.749 658.664 324.829C658.533 324.928 658.377 324.981 658.215 324.981 658.018 324.981 657.825 324.899 657.683 324.756 657.476 324.547 657.41 324.243 657.501 323.97L657.542 323.87 657.606 323.765 657.698 323.657 661.221 320.232 661.34 320.101C661.852 319.482 661.931 318.611 661.556 317.917L661.469 317.771 661.368 317.632 661.235 317.482 660.561 316.799 660.432 316.68C659.821 316.164 658.959 316.085 658.272 316.464L658.128 316.552 657.99 316.654 657.841 316.788 653.401 321.276 653.283 321.406C652.773 322.023 652.695 322.894 653.07 323.587L653.157 323.733 653.258 323.873 653.473 324.12C653.571 324.254 653.622 324.41 653.622 324.573 653.622 324.776 653.543 324.97 653.4 325.114 653.104 325.413 652.628 325.413 652.331 325.114 651.157 323.927 651 322.063 651.92 320.697L652.041 320.529 652.172 320.368 652.337 320.19 656.765 315.715 656.914 315.573Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinks);
export default __webpack_public_path__ + "static/media/external_links.b925759f9c4e99f8ce5b460053e8f38a.svg";
export { ForwardRef as ReactComponent };